<template>
  <table-blue v-if="transfers && transfers.length" :cols="cols">
     <tr v-for="(item, index) in transfers" :key="index" :class="index % 2 ? 'even' : 'odd'">
      <table-blue-label-date :timestamp="item.timestamp" />
      <table-blue-label-action :action="item.action" />
      <table-blue-label-amount :action="item.action" :amount="item.amount" />
    </tr>
  </table-blue>
  <table-blue-no-result v-else />
</template>

<script>
import TableBlue from './TableBlue/TableBlue';
import TableBlueLabelDate from './TableBlue/TableBlueLabelDate';
import TableBlueLabelAction from './TableBlue/TableBlueLabelAction';
import TableBlueLabelAmount from './TableBlue/TableBlueLabelAmount';
import TableBlueNoResult from './TableBlue/TableBlueNoResult';

export default {
  name: 'TableBlueClubTransfers',
  props: ['transfers'],
  data() {
    return {
      cols: [
        { i18n: 'th.date',   align: 'center' },
        { i18n: 'th.action', aligh: 'center' },
        { i18n: 'th.amount', aling: 'right' }
      ]
    }
  },
  components: {
    TableBlue,
    TableBlueLabelDate,
    TableBlueLabelAction,
    TableBlueLabelAmount,
    TableBlueNoResult,
  }
}
</script>

